import React from 'react'

import {
  ModalForm,
  CheckboxGroup
} from '../modal-form/modal-form'

import sortBy from 'lodash/sortBy'

import { Details, Row, Block } from '../../components/details/details'
import { ButtonRow, Button } from '../buttons'
import { TealBadge } from '../../components/data-card/data-card-parts'

import ServicingTabsContainer from '../../containers/servicings/servicing-tabs-container'

export default ({
  id,
  loading,
  name,
  spec,
  area,
  status,
  permissions = {},
  claimedByCurrentUser,
  requireImages,
  highPriority,
  location,
  pinnedComment,
  assignee,
  claimer,
  redone,
  labels,
  transferable,

  claim,
  toggleHighPriority,
  toggleTemporarilyOccupied,
  toggleInProgress,
  toggleRequireImages,
  unpinComment,
  transferArea,
  children
}) => {
  if (loading) {
    return <p>Loading...</p>
  }

  let servicingLabelBadges = servicingLabelBadges = <p>—</p>

  if (labels && labels.length > 0) {
    servicingLabelBadges = sortBy(labels, 'name').map(label => <TealBadge text={label.name} />)
  }

  return (
    <div className='servicing-details'>
      <Details>
        <Row>
          <Block title='room'><p>{area.name}</p></Block>
          <Block title='last cleaned'><p>{area.lastCleanedAt ? area.lastCleanedAt.format('MMMM Do, YYYY, h:mm A') : '—'}</p></Block>
          <Block title='last cleaning'><p>{(area.lastCleaning || []).join(', ') || '—'}</p></Block>
        </Row>
        {pinnedComment &&
          <Row>
            <Block title={
              <p>
                Comment <a href='#' onClick={(e) => unpinComment(e, pinnedComment.id)}>unpin</a>
              </p>
            }>
              <p>{pinnedComment.body}</p>
            </Block>
          </Row>}
        <Row>
          <Block>
            <ModalForm>
              <CheckboxGroup>
                <label htmlFor='isHighPriority'>
                  <input
                    type='checkbox'
                    id='isHighPriority'
                    checked={highPriority}
                    onChange={toggleHighPriority.bind(null, !highPriority)}
                  />
                  <span className='indicator' />
                  High Priority
                </label>
                <label htmlFor='isInProgress'>
                  <input
                    type='checkbox'
                    id='isInProgress'
                    checked={status === 'in_progress'}
                    onChange={toggleInProgress.bind(null, status === 'in_progress')}
                  />
                  <span className='indicator' />
                  In Progress
                </label>
                <label htmlFor='isRedo' className='disabled'>
                  <input
                    type='checkbox'
                    id='isRedo'
                    checked={redone}
                    disabled
                  />
                  <span className='indicator' />
                  Redo
                </label>
                <label htmlFor='requireImages'>
                  <input
                    type='checkbox'
                    id='requireImages'
                    checked={requireImages}
                    onChange={toggleRequireImages.bind(null, !requireImages)}
                  />
                  <span className='indicator' />
                  Require Images
                </label>
              </CheckboxGroup>
            </ModalForm>
            {requireImages &&
              <ButtonRow>
                <Button small to={location.pathname + '/images'}>
                  View before/after images
                </Button>
              </ButtonRow>
            }
          </Block>

          <Block title='labels'>
            <div className='servicing-detail-labels'>
              {servicingLabelBadges}
            </div>

            <ButtonRow>
              <Button small to={location.pathname + "/labels"}>
                Manage Labels
              </Button>
            </ButtonRow>
          </Block>

          <Block title='actions'>
            <ButtonRow>
              {permissions.canClaim &&
                <Button
                  small
                  onClick={claim}
                  disabled={claimedByCurrentUser}
                >
                  {claimedByCurrentUser ? '✓ Claimed' : 'Claim'}
                </Button>
              }

              {permissions.canAssign &&
                <Button small to={location.pathname + '/assign'}>
                  {assignee ? assignee.name : claimer ? claimer.name : 'Assign Area'}
                </Button>
              }
            </ButtonRow>
            <ButtonRow>
              {spec && spec.url
                ? (<Button small externalUrl={spec.url} download>View Room PDF</Button>)
                : (<Button small disabled>No PDF Available</Button>)}
            </ButtonRow>
            <ButtonRow>
              <Button small onClick={transferArea} disabled={!transferable}>Transfer</Button>
            </ButtonRow>
          </Block>
        </Row>
      </Details>

      <ServicingTabsContainer servicingId={id} areaId={area.id} location={location} />
      {children}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/servicings/servicing-details.js